import { useCallback } from 'react';

export const useBlurActiveElement = () => {
  const blurActiveElement = useCallback(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, []);

  return { blurActiveElement };
};
